<template>
    <app-data-table
        :fields="fields"
        :items="tableData"
        @sort="onSort"
        :current-page="data.current_page"
        :last-page="data.last_page"
        :from="data.from"
        :to="data.to"
        :total="data.total"
        :per-page="data.per_page"
        :on-change-page="onChangePage"
    >
        <template slot="actions" slot-scope="{ item }">
            <b-button variant="danger" @click="deleteAssociation(item)"><i class="fa fa-trash"></i></b-button>
        </template>
    </app-data-table>
    
</template>
<script>
    export default {
        data(){
            return {
                fields: [
                    {
                        key: 'menu_option.menu.name',
                        label: 'Menú',
                        filter: true
                    },
                    {
                        key: 'menu_option.name',
                        label: 'Opción',
                        filter: true
                    },
                    {
                        key: 'menu_option.description',
                        label: 'Descripción',
                        filter: true
                    },
                    {
                        key: 'actions',
                        label: 'Acciones'
                    }
                ]
            }
        },
        computed: {
            tableData(){
                if(!this.data || !this.data.data) return [];

                return this.data.data;
            }
        },
        props: {
            data: {
                required: true
            },
            onChangePage: {
                type: Function,
                required: true
            }
        },
        methods: {
            deleteAssociation(data){
                this.$emit('delete-association', data);
            },
            onSort(ctx) {
                this.$emit('sort', ctx);
            },
        }
    }
</script>